/*@flow*/
import assert from './assert';
import getTypeName from './getTypeName';
import type { TypeT } from './types';

export default function forbidNewOperator(x: any, type: TypeT<*>) {
  assert(!(x instanceof type), function() {
    return (
      'Cannot use the new operator to instantiate the type ' + getTypeName(type)
    );
  });
}
